module.exports = __webpack_public_path__ + "static/media/chevron-up.779c9d72.svg";